import { createAction, props } from '@ngrx/store';
import {
  RequestErpSyncStatusCommandV1,
  SupplierRequestDetailV1,
  SupplierRequestExternalCommandV1,
  SupplierRequestInternalCommandV1,
  SupplierRequestQueryV1,
} from 'src/app/api/models';

export enum RequestFormActionTypes {
  LOAD_REQUEST = '[REQUEST_FORM] LOAD_REQUEST',
  LOAD_REQUEST_SUCCESS = '[REQUEST_FORM] LOAD_REQUEST_SUCCESS',
  LOAD_REQUEST_FAILED = '[REQUEST_FORM] LOAD_REQUEST_FAILED',

  SAVE_INTERNAL = '[REQUEST_FORM] SAVE_INTERNAL',
  SAVE_INTERNAL_SUCCESS = '[REQUEST_FORM] SAVE_INTERNAL_SUCCESS',
  SAVE_INTERNAL_FAILED = '[REQUEST_FORM] SAVE_INTERNAL_FAILED',

  SUBMIT_INTERNAL = '[REQUEST_FORM] SUBMIT_INTERNAL',
  SUBMIT_INTERNAL_SUCCESS = '[REQUEST_FORM] SUBMIT_INTERNAL_SUCCESS',
  SUBMIT_INTERNAL_FAILED = '[REQUEST_FORM] SUBMIT_INTERNAL_FAILED',

  SAVE_EXTERNAL = '[REQUEST_FORM] SAVE_EXTERNAL',
  SAVE_EXTERNAL_SUCCESS = '[REQUEST_FORM] SAVE_EXTERNAL_SUCCESS',
  SAVE_EXTERNAL_FAILED = '[REQUEST_FORM] SAVE_EXTERNAL_FAILED',

  SUBMIT_EXTERNAL = '[REQUEST_FORM] SUBMIT_EXTERNAL',
  SUBMIT_EXTERNAL_SUCCESS = '[REQUEST_FORM] SUBMIT_EXTERNAL_SUCCESS',
  SUBMIT_EXTERNAL_FAILED = '[REQUEST_FORM] SUBMIT_EXTERNAL_FAILED',

  UPDATE_ERP_SYNC_STATUS = '[REQUEST_FORM] UPDATE_ERP_SYNC_STATUS',
  UPDATE_ERP_SYNC_STATUS_SUCCESS = '[REQUEST_FORM] UPDATE_ERP_SYNC_STATUS_SUCCESS',
  UPDATE_ERP_SYNC_STATUS_FAILED = '[REQUEST_FORM] UPDATE_ERP_SYNC_STATUS_FAILED',

  CLEAR_ERROR = '[REQUEST_FORM] CLEAR_ERROR',
  RESET = '[REQUEST_FORM] RESET',
}

export const loadRequest = createAction(RequestFormActionTypes.LOAD_REQUEST, props<{ requestId: string }>());

export const loadRequestSuccess = createAction(
  RequestFormActionTypes.LOAD_REQUEST_SUCCESS,
  props<{ requestId: string; request: SupplierRequestDetailV1 }>()
);

export const loadRequestFailed = createAction(RequestFormActionTypes.LOAD_REQUEST_FAILED, props<{ error?: unknown }>());

export const saveInternal = createAction(
  RequestFormActionTypes.SAVE_INTERNAL,
  props<{ requestId: string; body: SupplierRequestInternalCommandV1 }>()
);

export const saveInternalSuccess = createAction(
  RequestFormActionTypes.SAVE_INTERNAL_SUCCESS,
  props<{ requestId: string }>()
);

export const saveInternalFailed = createAction(
  RequestFormActionTypes.SAVE_INTERNAL_FAILED,
  props<{ error?: unknown }>()
);

export const submitForInternalReview = createAction(
  RequestFormActionTypes.SUBMIT_INTERNAL,
  props<{ requestId: string; body: SupplierRequestInternalCommandV1 }>()
);

export const submitForInternalReviewSuccess = createAction(
  RequestFormActionTypes.SUBMIT_INTERNAL_SUCCESS,
  props<{ requestId: string }>()
);

export const submitForInternalReviewFailed = createAction(
  RequestFormActionTypes.SUBMIT_INTERNAL_FAILED,
  props<{ error?: unknown }>()
);

export const saveExternal = createAction(
  RequestFormActionTypes.SAVE_EXTERNAL,
  props<{ requestId: string; body: SupplierRequestExternalCommandV1 }>()
);

export const saveExternalSuccess = createAction(
  RequestFormActionTypes.SAVE_EXTERNAL_SUCCESS,
  props<{ requestId: string }>()
);

export const saveExternalFailed = createAction(
  RequestFormActionTypes.SAVE_EXTERNAL_FAILED,
  props<{ error?: unknown }>()
);

export const submitForExternalReview = createAction(
  RequestFormActionTypes.SUBMIT_EXTERNAL,
  props<{ requestId: string; body: SupplierRequestExternalCommandV1 }>()
);

export const submitForExternalReviewSuccess = createAction(
  RequestFormActionTypes.SUBMIT_EXTERNAL_SUCCESS,
  props<{ requestId: string }>()
);

export const submitForExternalReviewFailed = createAction(
  RequestFormActionTypes.SUBMIT_EXTERNAL_FAILED,
  props<{ error?: unknown }>()
);

export const updateErpSyncStatus = createAction(
  RequestFormActionTypes.UPDATE_ERP_SYNC_STATUS,
  props<{ requestId: string; body: RequestErpSyncStatusCommandV1 }>()
);

export const updateErpSyncStatusSuccess = createAction(
  RequestFormActionTypes.UPDATE_ERP_SYNC_STATUS_SUCCESS,
  props<{ requestId: string; request: SupplierRequestQueryV1 }>()
);

export const updateErpSyncStatusFailed = createAction(
  RequestFormActionTypes.UPDATE_ERP_SYNC_STATUS_FAILED,
  props<{ error?: unknown }>()
);

export const clearError = createAction(RequestFormActionTypes.CLEAR_ERROR);

export const resetRequestForm = createAction(RequestFormActionTypes.RESET);
